const getters = {
  isFetching: 'isFetching',
  isAppInitialised: 'isAppInitialised',
  currenciesCodes: 'currenciesCodes'
}

export const {
  isFetching,
  isAppInitialised,
  currenciesCodes
} = getters

export default getters
